export interface TablePaginator {
  rows: number;
  total: number;
  current_page: number;
  total_pages: number;
  per_page: number;
  first?: number;
}
